var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.resolvedView,_vm._b({tag:"component"},'component',_vm.resolvedData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }